<template>
  <div>
    <div id="cancel-single-apparatus-multiple-subscriptions" role="dialog" class="modal fade show">
      <div class="modal-dialog modal-dialog-centered modal-lg" style="width: 560px;">
        <span tabindex="0"></span>
        <div tabindex="-1" class="modal-content">
          <header class="modal-header">
            <div class="row w-100 no-gutters align-items-center">
              <div class="col">
                <h2 class="modal-title">
                  <i class="far fa-circle-dollar colorOrange mr-1" />
                  {{ $t('xCancelPlanLowercase') }}
                </h2>
              </div>
              <div class="float-right col-auto">
                <button
                  type="button"
                  class="btn btn-icon-button--gray btn-icon-button"
                  @click="closeGenWithMultipleSubscriptionsModal()"
                >
                  <i class="fas fa-times" />
                </button>
              </div>
            </div>
          </header>
          <div class="modal-body">
            <div class="row">
              <div class="col">
                {{
                  $t('xCancelPlanForMultipleSubs', {
                    0: currentPremiumSubscription?.subscriptionProductName,
                    1: currentPremiumSubscription?.subscriptionCost,
                    2: $moment(currentPremiumSubscription?.subscriptionRenewalDate).format($t('xShortDate')),
                    3: getApparatusTypeAsString,
                    4: apparatus?.preferredDealerName
                  })
                }}
              </div>
            </div>
          </div>
          <ModalFooter>
            <button type="button" @click="cancelPlan()" class="btn btn-primary flex flex-grow-1">
              {{ $t('xCancelPlanLowercase') }}
            </button>
          </ModalFooter>
        </div>
      </div>
    </div>

    <div id="remove-home-premium-apparatus-multiple-subscriptions" role="dialog" class="modal fade show">
      <div class="modal-dialog modal-dialog-centered modal-lg" style="width: 560px;">
        <span tabindex="0"></span>
        <div tabindex="-1" class="modal-content">
          <header class="modal-header">
            <div class="row w-100 no-gutters align-items-center">
              <div class="col">
                <h2 class="modal-title">
                  <i class="fa-regular fa-circle-info colorOrange mr-1" />
                  {{ $t('xRemoveProduct') }}
                </h2>
              </div>
              <div class="float-right col-auto">
                <button
                  type="button"
                  class="btn btn-icon-button--gray btn-icon-button"
                  @click="closeApparatusHomePremiumWithMultipleSubscriptionsModal()"
                >
                  <i class="fas fa-times" />
                </button>
              </div>
            </div>
          </header>
          <div class="modal-body">
            <div class="row">
              <div class="col">
                {{
                  $t('xRemovingApparatusForMultipleSubs', {
                    0: apparatus?.name
                  })
                }}
              </div>
            </div>
          </div>
          <ModalFooter>
            <button
              type="button"
              @click="closeApparatusHomePremiumWithMultipleSubscriptionsModal()"
              class="btn btn-secondary flex flex-grow-1"
            >
              {{ $t('xNoKeepThisProduct') }}
            </button>
            <button type="button" @click="removePlan()" class="btn btn-primary flex flex-grow-1">
              {{ $t('xYesRemoveThisProduct') }}
            </button>
          </ModalFooter>
        </div>
      </div>
    </div>

    <div id="apparatus-with-multiple-subscriptions-mobile-platform" role="dialog" class="modal fade show">
      <div class="modal-dialog modal-dialog-centered modal-lg" style="width: 560px;">
        <span tabindex="0"></span>
        <div tabindex="-1" class="modal-content">
          <header class="modal-header">
            <div class="row w-100 no-gutters align-items-center">
              <div class="col">
                <h2 class="modal-title">
                  <i class="fa fa-exclamation-circle colorOrange mr-1" />
                  {{ $t('xYourAccountNeedsAttentionHeader') }}
                </h2>
              </div>
              <div class="float-right col-auto">
                <button
                  type="button"
                  class="btn btn-icon-button--gray btn-icon-button"
                  @click="closeApparatusWithMultipleSubscriptionsMobilePlatformModal()"
                >
                  <i class="fas fa-times" />
                </button>
              </div>
            </div>
          </header>
          <div class="modal-body">
            <div class="row">
              <div class="col">
                <div class="mb-3">
                  {{
                    $t('xApparatusHasMultipleSubsOnMobileBodyText1', {
                      0: apparatus?.name,
                      1: apparatus?.preferredDealerName,
                      2: currentPremiumSubscription?.subscriptionProductName,
                      3: $moment(currentPremiumSubscription?.subscriptionRenewalDate).format($t('xShortDate'))
                    })
                  }}
                </div>

                <div v-if="currentPremiumSubscription?.subscriptionStore === subscriptionStoreTypesApple">
                  <div>
                    {{ $t('xApparatusHasMultipleSubsOnAppleBodyText2') }}
                  </div>
                  <div>
                    {{ 'https://account.apple.com/account/manage/section/subscriptions.' }}
                  </div>
                </div>
                <div v-if="currentPremiumSubscription?.subscriptionStore === subscriptionStoreTypesGoogle">
                  <div>
                    {{ $t('xApparatusHasMultipleSubsOnAndroidBodyText2') }}
                  </div>
                  <div>
                    {{ 'https://play.google.com/store/account/subscriptions.' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ModalFooter>
            <button
              type="button"
              @click="closeApparatusWithMultipleSubscriptionsMobilePlatformModal()"
              class="btn btn-primary flex flex-grow-1"
            >
              {{ $t('xDone') }}
            </button>
          </ModalFooter>
        </div>
      </div>
    </div>

    <div id="remove-apparatus-with-multiple-subscriptions-mobile-platform" role="dialog" class="modal fade show">
      <div class="modal-dialog modal-dialog-centered modal-lg" style="width: 560px;">
        <span tabindex="0"></span>
        <div tabindex="-1" class="modal-content">
          <header class="modal-header">
            <div class="row w-100 no-gutters align-items-center">
              <div class="col">
                <h2 class="modal-title">
                  <i class="fa fa-exclamation-circle colorOrange mr-1" />
                  {{ $t('xYourAccountNeedsAttentionHeader') }}
                </h2>
              </div>
              <div class="float-right col-auto">
                <button
                  type="button"
                  class="btn btn-icon-button--gray btn-icon-button"
                  @click="closeRemoveApparatusWithMultipleSubscriptionsMobilePlatformModal()"
                >
                  <i class="fas fa-times" />
                </button>
              </div>
            </div>
          </header>
          <div class="modal-body">
            <div class="row">
              <div class="col">
                <div class="mb-3">
                  {{
                    $t('xRemoveApparatusHasMultipleSubsOnMobileBodyText1', {
                      0: apparatus?.name,
                      1: apparatus?.preferredDealerName,
                      2: getApparatusTypeAsString,
                      3: currentPremiumSubscription?.subscriptionProductName
                    })
                  }}
                </div>

                <div v-if="currentPremiumSubscription?.subscriptionStore === subscriptionStoreTypesApple">
                  <div>
                    {{ $t('xRemoveApparatusHasMultipleSubsOnAppleBodyText2') }}
                  </div>
                  <div>
                    {{ 'https://account.apple.com/account/manage/section/subscriptions.' }}
                  </div>
                </div>
                <div v-if="currentPremiumSubscription?.subscriptionStore === subscriptionStoreTypesGoogle">
                  <div>
                    {{ $t('xRemoveApparatusHasMultipleSubsOnAndroidBodyText2') }}
                  </div>
                  <div>
                    {{ 'https://play.google.com/store/account/subscriptions.' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ModalFooter>
            <button
              type="button"
              @click="closeRemoveApparatusWithMultipleSubscriptionsMobilePlatformModal()"
              class="btn btn-primary flex flex-grow-1"
            >
              {{ $t('xDone') }}
            </button>
          </ModalFooter>
        </div>
      </div>
    </div>

    <Modal modalId="cancel-multiple-subscriptions-spinner-modal" size="modal-lg">
      <ModalBody style="padding-top: 100px; padding-bottom: 100px;">
        <div class="d-flex justify-content-center align-items-center">
          <b-spinner style="width: 10rem; height: 10rem;" variant="warning"></b-spinner>
        </div>
      </ModalBody>
    </Modal>
  </div>
</template>

<script>
import * as Constants from '@/constants'

export default {
  props: ['accountProfile', 'apparatus', 'currentPremiumSubscription', 'immediatelyOpen'],
  computed: {
    subscriptionStoreTypesApple() {
      return Object.values(Constants.SubscriptionStoreTypes).indexOf('Apple')
    },
    subscriptionStoreTypesGoogle() {
      return Object.values(Constants.SubscriptionStoreTypes).indexOf('Google')
    },
    getApparatusTypeAsString() {
      switch (this.apparatus?.type) {
        case Constants.HsbApparatusType:
          return this.$t('xGeneratorLowercase')
        case Constants.FuelTankApparatusType:
          return this.$t('xFuelMonitorLowercase')
        default:
          return ''
      }
    }
  },
  methods: {
    closeGenWithMultipleSubscriptionsModal() {
      document.getElementById('cancel-single-apparatus-multiple-subscriptions').style.display = 'none'
    },
    closeApparatusHomePremiumWithMultipleSubscriptionsModal() {
      document.getElementById('remove-home-premium-apparatus-multiple-subscriptions').style.display = 'none'
    },
    closeApparatusWithMultipleSubscriptionsMobilePlatformModal() {
      document.getElementById('apparatus-with-multiple-subscriptions-mobile-platform').style.display = 'none'
    },
    closeRemoveApparatusWithMultipleSubscriptionsMobilePlatformModal() {
      document.getElementById('remove-apparatus-with-multiple-subscriptions-mobile-platform').style.display = 'none'
    },
    async cancelPlan() {
      this.closeGenWithMultipleSubscriptionsModal()
      this.openModal('cancel-multiple-subscriptions-spinner-modal')
      await this.$store
        .dispatch('cancelSubscriptionProduct', {
          organizationId: this.accountProfile.organizationId,
          store: this.currentPremiumSubscription?.subscriptionStore,
          productId: this.currentPremiumSubscription?.subscriptionProductId
        })
        .then(() => {
          this.$store.dispatch('displayToast', {
            title: this.$t('xSuccess'),
            message: this.$t('xPlanCanceled'),
            variant: 'success'
          })

          setTimeout(() => {
            window.location.reload()
          }, 3000)
        })
        .catch(() => {
          this.$store.dispatch('displayToast', {
            title: this.$t('xSomethingWentWrong'),
            message: this.$t('xPleaseWaitAndTryAgain'),
            variant: 'danger'
          })
        })
        .finally(() => {
          this.closeModal('cancel-multiple-subscriptions-spinner-modal')
        })
    },
    async removePlan() {
      this.closeApparatusHomePremiumWithMultipleSubscriptionsModal()
      this.openModal('cancel-multiple-subscriptions-spinner-modal')
      let subscriptionApparatusList = this.currentPremiumSubscription?.apparatuses
        .map(subscriptionApparatus => {
          return subscriptionApparatus.id
        })
        .filter(apparatusId => apparatusId !== this.apparatus?.apparatusId)
      await this.$store
        .dispatch('updateSubscriptionApparatuses', {
          organizationId: this.accountProfile.organizationId,
          store: this.currentPremiumSubscription?.subscriptionStore,
          productId: this.currentPremiumSubscription?.subscriptionProductId,
          apparatusIds: subscriptionApparatusList
        })
        .then(async () => {
          await this.$store
            .dispatch('getSubscriptionDetails', this.accountProfile.organizationId)
            .then(response => {
              let removedApparatusPlan = response.data?.subscriptions?.find(
                subscription => subscription.store !== Object.values(Constants.SubscriptionStoreTypes).indexOf('Dealer')
              )
              this.$store.dispatch('displayToast', {
                title: this.planEligibleForDowngrade(removedApparatusPlan)
                  ? this.$t('xProductsRemovedSuccessfully')
                  : this.$t('xSuccess'),
                message: this.planEligibleForDowngrade(removedApparatusPlan)
                  ? this.$t('xYourPlanEligibleForDowngrade')
                  : this.$t('xProductsRemovedSuccessfully'),
                variant: 'success'
              })

              setTimeout(() => {
                window.location.reload()
              }, 3000)
            })
            .catch(() => {
              this.$store.dispatch('displayToast', {
                title: this.$t('xSomethingWentWrong'),
                message: this.$t('xPleaseWaitAndTryAgain'),
                variant: 'danger'
              })
            })
        })
        .catch(() => {
          this.$store.dispatch('displayToast', {
            title: this.$t('xSomethingWentWrong'),
            message: this.$t('xPleaseWaitAndTryAgain'),
            variant: 'danger'
          })
        })
        .finally(() => {
          this.closeModal('cancel-multiple-subscriptions-spinner-modal')
        })
    }
  },
  mounted() {
    if (this.immediatelyOpen) {
      if (
        this.isSingleApparatusSubscription(this.currentPremiumSubscription?.subscriptionProductId) ||
        this.currentPremiumSubscription?.apparatuses.length === 1
      ) {
        this.openModal('cancel-single-apparatus-multiple-subscriptions')
      } else if (this.isHomePremiumSubscription(this.currentPremiumSubscription?.subscriptionProductId)) {
        this.openModal('remove-home-premium-apparatus-multiple-subscriptions')
      }
    }
  }
}
</script>
